export default __webpack_public_path__ + "static/media/logo-white.7888d8ce.png";